module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-4.97ea34b2.svg";